import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

export class ConfirmDialog {
  public config: any;
  public onClose = new Subject();

  constructor(config?) {
    this.config = config;
  }

  close(value) {
    this.onClose.next(value);
  }
}

@Component({
  selector: 'pos-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  public config = {
    title: 'Unsaved Changes',
    message: 'Are you sure you want to continue?',
    acceptButton: 'Confirm',
    cancelButton: 'Cancel'
  };
  public modalVisible = false;
  public instance: ConfirmDialog;

  constructor() {
    this.instance = new ConfirmDialog(this.config);
  }

  ngOnInit() {}

  public show(newconfig?: any) {
    if (this.instance) {
      this.instance.onClose.complete();
      delete this.instance;
    }
    this.modalVisible = true;
    const config = JSON.parse(JSON.stringify(this.config));
    this.instance = new ConfirmDialog(Object.assign(config, newconfig) || this.config);
    return this.instance;
  }

  public close(value?: any) {
    this.modalVisible = false;
    this.instance.close(value);
  }
}
